import { find } from 'lodash';
import router from './router';

export const fetchResource = (api, mutationType) =>
  ({ commit, state }, { id, force = false }) => {
    if (!state.show || state.show.data.id.toString() !== id || force) {
      commit(mutationType, null);
      const promise = api.get(id);
      promise.then((response) => {
        commit(mutationType, response.data);
      }).catch((error) => {
        if (error.response && error.response.status === 404) {
          router.replace('/404');
        }
      });
      return promise;
    }
    return null;
  };

export const getIncludedData = (stateAttribute, relationship) =>
  stateAttribute && find(
    stateAttribute.included,
    stateAttribute.data.relationships[relationship].data,
  );

export const getIncludedGoogleDocByKind = (stateAttribute, kind) =>
  stateAttribute &&
  stateAttribute.included &&
  stateAttribute.included.filter(doc =>
    doc.type === 'googleDriveDocument' && doc.attributes.kind === kind
  );

export const getArrayIncludedData = (stateAttribute, relationship) =>
  stateAttribute && stateAttribute.data.relationships[relationship].data.map(el =>
    find(
      stateAttribute.included,
      el,
    ));
